import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import {
  ButtonsModule,
  CardsModule,
  IconsModule,
  InputsModule,
  InputUtilitiesModule,
  WavesModule
} from "ng-uikit-pro-standard";
import {ReactiveFormsModule} from "@angular/forms";



@NgModule({
    declarations: [
        LoginComponent,
        RegisterComponent
    ],
  exports: [
    LoginComponent,
    RegisterComponent
  ],
  imports: [
    CommonModule,
    CardsModule,
    IconsModule,
    ReactiveFormsModule,
    InputUtilitiesModule,
    InputsModule,
    ButtonsModule,
    WavesModule
  ]
})
export class AuthModule { }
